<nb-card 
	[nbSpinner]="loading"
	nbSpinnerStatus="primary"
	nbSpinnerSize="large"
>
	<nb-card-header>
		<span class="info-text">{{
			'MENU.IMPORT_EXPORT.EXPORT_MESSAGE' | translate
		}}</span>
	</nb-card-header>
	<nb-card-header>
		<div class="row">
			<div class="col-sm-12 col-md-6 text-left">
				<div class="mt-3">
					<nb-checkbox
						[checked]="checkedAll"
						status="basic"
						(checkedChange)="onCheckboxChangeAll($event)"
					>
						ALL Entities
					</nb-checkbox>
				</div>
			</div>
			<div class="col-sm-12 col-md-6 text-right">
				<button
					class="m-1"
					nbButton
					shape="round"
					status="info"
					size="large"
					type="submit"
					value="Export"
					(click)="onSubmit()"
				>
					<nb-icon icon="download-outline"></nb-icon>
					{{ 'MENU.IMPORT_EXPORT.EXPORT' | translate }}
				</button>
			</div>
		</div>
	</nb-card-header>
	<nb-card-body>
		<div class="row">
			<form>
				<nb-card-body>
					<div class="row">
						<ng-container
							*ngFor="let entity of entities; let i = index"
						>
							<div class="col-sm-12 col-md-12">
								<nb-card-body class="p-0">
									<nb-card>
										<nb-card-header>
											<nb-checkbox
												[checked]="entity.checked"
												status="basic"
												(checkedChange)="
													onCheckboxChange(
														$event,
														entity
													)
												"
												>{{ entity?.name }}
											</nb-checkbox>
										</nb-card-header>
										<ng-container *ngIf="entity.isGroup">
											<nb-card-body>
												<ng-container
													*ngFor="
														let item of entity.entities;
														let j = index
													"
												>
													<div
														class="col-sm-12 col-md-3 float-left"
													>
														<nb-checkbox
															[checked]="
																entity.checked
															"
															status="basic"
															(checkedChange)="
																onCheckboxChange(
																	$event,
																	item
																)
															"
															>{{ item?.name }}
														</nb-checkbox>
													</div>
												</ng-container>
											</nb-card-body>
										</ng-container>
									</nb-card>
								</nb-card-body>
							</div>
						</ng-container>
					</div>
				</nb-card-body>
			</form>
		</div>
	</nb-card-body>
</nb-card>
